// Module
var code = "<svg class=\"svg-icon-check\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <circle cx=\"13\" cy=\"13\" r=\"13\" fill=\"#ACFFCD\"/> <path d=\"M7.25781 12.5662L10.9411 16.1954L18.687 9.85791\" stroke=\"white\" stroke-width=\"2.70833\" stroke-linecap=\"round\"/> </svg> ";
// Exports
module.exports = code;